import React from "react";

import SaveIcon from "@mui/icons-material/Save";
import IconBtnTemplate from "./IconBtnTemplate";

type IconSize = "small" | "inherit" | "medium" | "large";
type ButtonType = "success" | "danger" | "warning" | "info" | "generic";

interface SaveIconBtnProps {
  action: (event?: React.MouseEvent<HTMLButtonElement>) => void;
  type?: ButtonType;
  size?: IconSize;
  tip?: string;
}

export default function SaveIconBtn({
  action,
  type = "info",
  size = "medium",
  tip = "Save",
}: SaveIconBtnProps) {
  return (
    <IconBtnTemplate
      type={type}
      action={action}
      icon={<SaveIcon fontSize={size} />}
      tip={tip}
    />
  );
}
